export const isEmpty = (value) => {
  if (value == null) {
    return true;
  }
  if (Array.isArray(value) || typeof value == 'string') {
    return !value.length;
  }
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
};
